import {createPortal} from 'react-dom';

type Props = React.PropsWithChildren;

// @TODO copied from component-library, re-export there instead
export const LayerPortal: React.FunctionComponent<Props> = ({children}) => {
  const domNode =
    typeof document === 'object'
      ? document.getElementById('portal-root')
      : null;

  return domNode ? createPortal(children, domNode) : <>{children}</>;
};
